export const EMPTY_ROOM_LABEL = "—";

type RoomLike =
  | {
      number?: number | string | null;
      category?: { name?: string | null } | null;
    }
  | null
  | undefined;

export const formatRoomCell = (
  room: RoomLike,
): { roomNumber: string; categoryName?: string } => {
  const number = room?.number;
  const hasNumber = number !== null && number !== undefined && number !== "";
  return {
    roomNumber: hasNumber ? String(number) : EMPTY_ROOM_LABEL,
    categoryName: room?.category?.name || undefined,
  };
};
